var _Lock_releaseAsync, _Mutex_onRelease;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import SingleInvokeEvent from './Events/SingleInvokeEvent';
import isUndefined from './TypeHelpers/isUndefined';
import CancellationToken from './Promises/CancellationToken';
class Lock {
    constructor(releaseAsync) {
        _Lock_releaseAsync.set(this, void 0);
        __classPrivateFieldSet(this, _Lock_releaseAsync, releaseAsync, "f");
    }
    releaseAsync(cancellationToken = CancellationToken.default) {
        return __classPrivateFieldGet(this, _Lock_releaseAsync, "f").call(this, cancellationToken);
    }
}
_Lock_releaseAsync = new WeakMap();
/**
 * Creates a mutex that when acquired will return a lock that needs to be released
 * before any waiting code can be run.
 */
export default class Mutex {
    constructor() {
        _Mutex_onRelease.set(this, void 0);
    }
    /** Acquires a lock on this mutex. Only one lock can be kept at a time; calling multiple times will create dependent locks */
    async acquireAsync(cancellationToken = CancellationToken.default) {
        if (!isUndefined(__classPrivateFieldGet(this, _Mutex_onRelease, "f"))) {
            await this.waitAsync(cancellationToken);
        }
        __classPrivateFieldSet(this, _Mutex_onRelease, new SingleInvokeEvent(), "f");
        return new Lock(() => {
            return new Promise((resolve, reject) => {
                try {
                    __classPrivateFieldGet(this, _Mutex_onRelease, "f") && __classPrivateFieldGet(this, _Mutex_onRelease, "f").invoke(this, {});
                    __classPrivateFieldSet(this, _Mutex_onRelease, undefined, "f");
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            });
        });
    }
    /**
     * Returns a promise that can be awaited until the lock is released.
     * If there is no lock the promise is resolved immediately.
     */
    waitAsync(cancellationToken = CancellationToken.default) {
        return new Promise((resolve, reject) => {
            cancellationToken.onCancelled.addHandler(() => reject());
            try {
                if (isUndefined(__classPrivateFieldGet(this, _Mutex_onRelease, "f"))) {
                    // not acquired
                    return resolve();
                }
                else {
                    // resolve promise when lock is released
                    __classPrivateFieldGet(this, _Mutex_onRelease, "f").addHandler(() => resolve());
                }
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
_Mutex_onRelease = new WeakMap();
export async function lockAsync(mutex, func, cancellationToken = CancellationToken.default) {
    const lock = await mutex.acquireAsync(cancellationToken);
    const result = await func();
    await lock.releaseAsync(cancellationToken);
    return result;
}
